import React from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { Box, Button, Container, Typography } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

export default function TripPlannerChatPage() {
  const { chatId } = useParams<{ chatId?: string }>();
  const { search } = useLocation();
  const destination = chatId === 'stats' ? 'stats' : chatId ? encodeURIComponent(chatId) : '';
  const url = `${window.configs.API_HOST}/api/trips/admin/${destination}${search}`;

  return (
    <Container maxWidth="xl">
      <PageHeader title="Trip Admin" />
      <Box mt={4}>
        <Typography>Trip Planner conversations and statistics have moved to Trip Admin.</Typography>
        <Button href={url} variant="contained" sx={{ mt: 2 }}>
          Open Trip Admin
        </Button>
      </Box>
    </Container>
  );
}
